import React from "react";
import { Outlet } from "react-router";

export function PageContent() {
    return (
        <React.Fragment>
            <Outlet />
        </React.Fragment>
    );
}
